import { z } from 'zod';
import { PartnerMaterialAdminSchema, PartnerMaterialCategorySchema, PartnerMaterialTextSchema, PartnerMaterialVideoUrlSchema } from '../../entities/partner-material/partner-material.schema';
const common = {
    category: PartnerMaterialCategorySchema,
    title: PartnerMaterialTextSchema,
    description: PartnerMaterialTextSchema.partial().optional()
};
/**
 * Create Partner Material Request
 * POST /api/v2/admin/partner-materials
 *
 * A file material starts without files; one file per language is attached
 * through the upload endpoints. New materials start as drafts so an empty one
 * never reaches partners.
 */ export const CreatePartnerMaterialRequestSchema = z.discriminatedUnion('kind', [
    z.object({
        kind: z.literal('file'),
        ...common
    }),
    z.object({
        kind: z.literal('video'),
        ...common,
        videoUrl: PartnerMaterialVideoUrlSchema
    })
]);
export const CreatePartnerMaterialResponseSchema = z.object({
    data: PartnerMaterialAdminSchema
});

//# sourceMappingURL=create-partner-material.schema.js.map